import { inject, Injectable } from '@angular/core';
import { HelperService } from '../helper.service';
import { Browser } from '@capacitor/browser';
import { PluginListenerHandle } from '@capacitor/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CartStatusUpdate } from '../store/+state/stores.actions';

@Injectable({
  providedIn: 'root',
})
export class PaymentRedirectService {
  private helperService = inject(HelperService);
  private router = inject(Router);
  private store = inject(Store);

  private listeners: Promise<PluginListenerHandle>[] = [];
  private originUrl: string = '';

  public closedByRedirection: boolean = false;

  handlePaymentNavigation(url: string, originUrl: string = null) {
    this.originUrl = originUrl;

    if (this.helperService.isMobileApp()) {
      this.closedByRedirection = false;

      Browser.open({ url });

      this.listeners.push(
        Browser.addListener('browserFinished', () => {
          this.clearListeners().catch((err) => console.error(err));

          if (!this.closedByRedirection) {
            if (this.originUrl) {
              const normalized = this.normalizeUrl(this.originUrl);
              this.router.navigate([normalized.path], {
                queryParams: normalized.queryParams,
                fragment: normalized.fragment,
                onSameUrlNavigation: 'reload',
              });
            }

            this.store.dispatch(new CartStatusUpdate('LOADED'));
          }
        }),
      );
    } else {
      window.top.location.href = url;
    }
  }

  async clearListeners() {
    const listenersResolved = await Promise.all(this.listeners);
    listenersResolved.forEach((listenerResolved) => {
      listenerResolved?.remove();
    });

    this.listeners = [];
  }

  closeMobileBrowser() {
    Browser.close().catch((err) => console.warn('Browser.close failed:', err));
  }

  setOriginUrl(url: string) {
    this.originUrl = url;
  }

  private normalizeUrl(url: string) {
    try {
      const parsed = new URL(url);

      const queryParams: any = {};
      parsed.searchParams.forEach((value, key) => {
        queryParams[key] = value;
      });

      return {
        path: parsed.pathname,
        queryParams,
        fragment: parsed.hash ? parsed.hash.substring(1) : undefined,
      };
    } catch (error) {
      return {
        path: '/',
        queryParams: '',
        fragment: 'cart',
      };
    }
  }
}
